import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  dataStreamResolver,
  deletedResolver,
  documentIdResolver,
  documentMetaTagsResolver,
  domainResolver,
  faviconResolver,
  isDocumentModeResolver,
  isRetweetResolver,
  isTitleRtlResolver,
  isTweetResolver,
  postIdResolver,
  postTypeResolver,
  sourceNameResolver,
  sourceTypeResolver,
  titleResolver,
  urlResolver
} from './document'

const streamDataFieldResolvers: FieldResolver[] = [
  dataStreamResolver,
  deletedResolver,
  documentIdResolver,
  documentMetaTagsResolver,
  domainResolver,
  faviconResolver,
  isDocumentModeResolver,
  isRetweetResolver,
  isTitleRtlResolver,
  isTweetResolver,
  postIdResolver,
  postTypeResolver,
  sourceNameResolver,
  sourceTypeResolver,
  titleResolver,
  urlResolver
]

const documentRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default documentRelatedFieldsResolver
